import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AppService } from './app.service';
import { ProfileSelectionComponentInfo } from 'libs/abc/core/authentication/src/lib/profile-selection/profile-selection-component-info';

@Injectable()
export class HasOrderGuard {
  constructor(private router: Router, private route: ActivatedRoute, private appService: AppService) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return state.url.endsWith(ProfileSelectionComponentInfo.ROUTE_PATH) || this.appService.ensureHasOrderOrTickets();
  }
}
